class GeneralTab {
  constructor() {
      this.graphOptions = ["Real Time", "History"]
      this.reads = {
          100: 100,
          500: 500,
          1000: 1000,
      }
      this.countries = _ALL_COUNTRIES
      this.tabElements = {
        key: "#key_value",
        deviceAddress: "#select_device",
        deviceType: "#select_device_type",
        graphType: "#select_graph", // 0 - Realtime | 1 - History
        reads: "#select_count",
        scale: "#select_scale",
        country: "#country",
        timezone: "#tz",
      }
      this.init();
  }

  init() {
      this.fillDeviceType()
      this.fillGraphType()
      this.fillScale()
      this.fillReads()
      this.fillCountries()
      const selectCountryElement = document.querySelector(this.tabElements.country);
      selectCountryElement.addEventListener("change", this.fillTimezones.bind(this));
  }

  fillDeviceType() {
      const selectDeviceType = document.querySelector(this.tabElements.deviceType)
      for (let device in ALL_DEVICES) {
          let option = document.createElement("option");
          option.value = devices[device].key_type;
          option.text = devices[device].name;
          selectDeviceType.add(option);
      }
  }

  fillGraphType() {
      const selectGraph = document.querySelector(this.tabElements.graphType);
      this.graphOptions.forEach((value, index) => {
          let option = document.createElement("option");
          option.text = value;
          option.value = index;
          if (isSummary == index) {
              option.setAttribute("selected", "");
          }
          selectGraph.add(option);
      });
  }

  fillScale() {
      let selectedScaleValue = "";
      if (_REQUEST.has("scale") && _REQUEST.get("scale") != "undefined") {
          selectedScaleValue = _REQUEST.get("scale");
      }
      const scaleLabel = document.querySelector("#scale_label");
      const selectScaleElement = document.createElement("select");
      selectScaleElement.setAttribute("id", "select_scale");
      if (isSummary === 1) {
          selectScaleElement.setAttribute("onchange", "change_select();");
      }
      scaleLabel.after(selectScaleElement);
      const selectScale = document.querySelector(this.tabElements.scale);
      for (let index in SUMMARY_SCALES) {
          let option = document.createElement("option");
          option.text = SUMMARY_SCALES[index].name;
          option.value = index;
          if (selectedScaleValue === index) {
              option.setAttribute("selected", "");
          }
          selectScale.add(option);
      }
  }  

  fillReads() {
      if (isSummary == 1) {
          document.querySelector(this.tabElements.scale).style.display = "block";
          document.querySelector("#scale_label").style.display = "block";
      } else {
          document.querySelector(this.tabElements.scale).style.display = "none";
          document.querySelector("#scale_label").style.display = "none";
      }
      updateGraphScaleOnSettings()
  }  

  fillCountries() {
      const countrySelectElement = document.querySelector(this.tabElements.country);
      countrySelectElement.innerHTML = ''
      let countryDefaultOption = document.createElement("option");
      countryDefaultOption.disabled = true
      countryDefaultOption.value = ""
      countryDefaultOption.text = '-- Select Country --';
      countrySelectElement.add(countryDefaultOption)

      const allCountries = this.countries

      for (let country in allCountries) {
          let countryOption = document.createElement("option");
          countryOption.value = country
          countryOption.text = allCountries[country]
          if (_REQUEST.has("timezone")) {
              if (_country === country) {
                  countryOption.setAttribute("selected", "");
              }
          } else {
              countryDefaultOption.selected = true
          }
          countrySelectElement.add(countryOption)
      }
      this.fillTimezones();
  }

  fillTimezones() {
      const countryCode = document.querySelector(this.tabElements.country).value;
      const timezoneSelectElement = document.querySelector(this.tabElements.timezone)
      timezoneSelectElement.innerHTML = ""
      const allTimezones = _ALL_TIMEZONES[countryCode];
      let timezoneDefaultOption = document.createElement("option");
      timezoneDefaultOption.disabled = true
      timezoneDefaultOption.value = ""
      timezoneDefaultOption.text = '-- Select Timezone --';
      timezoneSelectElement.add(timezoneDefaultOption)

      for (let timezone in allTimezones) {
          let timezoneOption = document.createElement("option");
          timezoneOption.value = timezone
          timezoneOption.text = allTimezones[timezone]
          if (_timezone === timezone) {
              timezoneOption.setAttribute("selected", "");
          }
          timezoneSelectElement.add(timezoneOption)
      }

      const countryHasOnlyOneTimezone = timezoneSelectElement.options.length === 2
      if (countryHasOnlyOneTimezone) {
          timezoneSelectElement.options[1].selected = true
          timezoneSelectElement.dispatchEvent(new Event('change'));
      } else if (_REQUEST.has("timezone")) {

      } else {
          timezoneDefaultOption.selected = true
      }
  }

  returnAllTabElements() {
    const paramsToReturn = {}
    for (let element in this.tabElements) {
      let returnElement = true
      if (document.querySelector(this.tabElements[element]).value) {
        const valueToReturn = document.querySelector(this.tabElements[element]).value
        if (element === 'reads') {
          if (parseInt(valueToReturn) === _DEFAULT_VALUES.reads) {
            returnElement = false 
          }
        } else if (element === 'scale') {
          if (parseInt(paramsToReturn.graphType) === 0) {
            returnElement = false 
          }
        }

        if (returnElement) {
          paramsToReturn[element] = valueToReturn
        }
      }
    }
    return paramsToReturn
  }

  getElementsToSaveInURL() {
    const paramsFromGeneralTab = this.returnAllTabElements()
    let elementsToSave = ""
    let { deviceType } = paramsFromGeneralTab
    elementsToSave = "key=" + paramsFromGeneralTab.key +
      "&deviceType=" + paramsFromGeneralTab.deviceType +
      "&deviceAddress=" + paramsFromGeneralTab.deviceAddress

    elementsToSave += paramsFromGeneralTab.scale ? "&scale=" + paramsFromGeneralTab.scale : "";
    elementsToSave += paramsFromGeneralTab.reads ? `&reads=${paramsFromGeneralTab.reads}` : "";
    elementsToSave += paramsFromGeneralTab.timezone ? `&timezone=${paramsFromGeneralTab.timezone}` : "";

    return elementsToSave
  }
}

class PulseTab {
  constructor() {
    this.tabElements = {
      kwh_tot_yname: "#kwh_tot_yname",
      kwh_tot_cost: "#kwh_tot_cost",
      kwh_currency: "#kwh_currency",

      pc_1_name: "#pc_1_name",
      pc_1_value: "#pc_1_value",
      pc_1_value_select: "#pc_1_value_select",
      pc1_cost: "#pc1_cost",
      pc1_currency: "#pc1_currency",
      pc_1_converted_select: "#pc_1_converted_select",

      pc_2_name: "#pc_2_name",
      pc_2_value: "#pc_2_value",
      pc_2_value_select: "#pc_2_value_select",
      pc2_cost: "#pc2_cost",
      pc2_currency: "#pc2_currency",
      pc_2_converted_select: "#pc_2_converted_select",

      pc_3_name: "#pc_3_name",
      pc_3_value: "#pc_3_value",
      pc_3_value_select: "#pc_3_value_select",
      pc3_cost: "#pc3_cost",
      pc3_currency: "#pc3_currency",
      pc_3_converted_select: "#pc_3_converted_select",

      pc_4_name: "#pc_4_name",
      pc_4_value: "#pc_4_value",
      pc_4_value_select: "#pc_4_value_select",
      pc4_cost: "#pc4_cost",
      pc4_currency: "#pc4_currency",
      pc_4_converted_select: "#pc_4_converted_select",
    }
    this.init()
  }

  init() {
      this.createPulseTab()
  }

  createPulseTab() {
      const tabSize = 4;
      const tabPulseKwh = document.querySelector("#tab_pulse_kwh_data");
      const tabsControl = document.querySelector("#tabs_control");
      let HTMLTag, elementId, elementClass, elementText, elementStyle, elementAttribute  = ""
      let tabIndex = 0
      for (let x = 0; x < tabSize; x++) {
        tabIndex = x + 1;
    
        let tabPulse = createHTMLElement(
          (HTMLTag = "li"),
          (elementId = "li_tab_pulse_" + tabIndex),
          (elementClass = ""),
          (elementText = ""),
          (elementStyle = ["opacity", 1]),
          (elementAttribute = [
            "onclick",
            "manageSettingTabs('tab_pulse_" + tabIndex + "')",
          ])
        );
        let aTabPulse = createHTMLElement(
          (HTMLTag = "a"),
          (elementId = "pulse" + (tabIndex + 1) + "a"),
          (elementClass = ""),
          (elementText = "Pulse " + tabIndex),
          (elementStyle = []),
          (elementAttribute = [])
        );
        tabPulse.appendChild(aTabPulse);
        tabsControl.appendChild(tabPulse);
    
        let pulseTab = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = "tab_pulse_" + tabIndex),
          (elementClass = "tabsdisplay"),
          (elementText = ""),
          (elementStyle = ["display", "none"])
        );
    
        // Div 1
        let pulseDiv1 = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "pulsediv")
        );
    
        let labelName = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = ""),
          (elementClass = "tablabel"),
          (elementText = "Name")
        );
        let inputId, inputClass, inputValue, inputMaxLength, inputType, inputStyle, inputAttribute = ""
        let inputName = createInput(
          (inputId = "pc_" + tabIndex + "_name"),
          (inputClass = "tab_pulse_input"),
          (inputValue = ""),
          (inputMaxLength = "25"),
          (inputType = "text"),
          (inputStyle = []),
          (inputAttribute = [])
        );
    
        pulseDiv1.appendChild(labelName);
        pulseDiv1.appendChild(inputName);
        pulseTab.appendChild(pulseDiv1);
    
        // Div 2
        let pulseDiv2 = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "pulsediv")
        );
        let labelPulseValue = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = ""),
          (elementClass = "tablabel"),
          (elementText = "Pulse Value")
        );
        let inputPc1 = createInput(
          (inputId = "pc_" + tabIndex + "_value"),
          (inputClass = "fixedwidth"),
          (inputValue = ""),
          (inputMaxLength = ""),
          (inputType = "number"),
          (inputStyle = ["opacity", 1, "width", "32px"]),
          (inputAttribute = ["onkeyup", "getConvertedValue(" + tabIndex + ")"])
        );
        let valueSelectPc1 = createHTMLElement(
          (HTMLTag = "select"),
          (elementId = "pc_" + tabIndex + "_value_select"),
          (elementClass = ""),
          (elementText = ""),
          (elementStyle = ["opacity", 1, "width", "108px"]),
          (elementAttribute = ["onchange", "getConvertedValue(" + tabIndex + ");"])
        );
        pulseDiv2.appendChild(labelPulseValue);
        pulseDiv2.appendChild(inputPc1);
        pulseDiv2.appendChild(valueSelectPc1);
        pulseTab.appendChild(pulseDiv2);
        // Div 3
        let pulseDiv3 = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "pulsediv")
        );
        let labelCostLabel = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = "pc" + tabIndex + "_cost_label"),
          (elementClass = "tablabel"),
          (elementText = `1 ${_OPTIONS_PULSE_VALUE[_DEFAULT_VALUES.pc_value_select]} = `)
        );
        let inputPc1Cost = createInput(
          (inputId = "pc" + tabIndex + "_cost"),
          (inputClass = "fixedwidth"),
          (inputValue = ""),
          (inputMaxLength = ""),
          (inputType = "number"),
          (inputStyle = ["opacity", 1, "width", "32px"]),
          (inputAttribute = ["onkeyup", "getConvertedValue(" + tabIndex + ")"])
        );
        let valueSelectPc1Currency = createHTMLElement(
          (HTMLTag = "select"),
          (elementId = "pc" + tabIndex + "_currency"),
          (elementClass = ""),
          (elementText = ""),
          (elementStyle = ["opacity", 1, "width", "108px"]),
          (elementAttribute = ["onchange", "getConvertedValue(" + tabIndex + ");"])
        );
    
        pulseDiv3.appendChild(labelCostLabel);
        pulseDiv3.appendChild(inputPc1Cost);
        pulseDiv3.appendChild(valueSelectPc1Currency);
        pulseTab.appendChild(pulseDiv3);
    
        // Inputs
        let inputPc1OptValue = createInput(
          (inputId = "pc_" + tabIndex + "_optvalue"),
          (inputClass = ""),
          (inputValue = _DEFAULT_VALUES.pc_value_select),
          (inputMaxLength = ""),
          (inputType = "hidden")
        );
        let inputPc1OptText = createInput(
          (inputId = "pc_" + tabIndex + "_opttext"),
          (inputClass = ""),
          (inputValue = _OPTIONS_PULSE_VALUE[_DEFAULT_VALUES.pc_value_select]),
          (inputMaxLength = ""),
          (inputType = "hidden")
        );
    
        pulseTab.appendChild(inputPc1OptValue);
        pulseTab.appendChild(inputPc1OptText);
        // Div4
        let pulseDiv4 = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = ""),
          (elementText = "Omnimeter v.4 Pulse Input:")
        );
        let divRCorners = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = "rcorners"),
          (elementClass = "pulsediv")
        );
        let labelPulseInputRatio = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = ""),
          (elementClass = "tablabel"),
          (elementText = "Pulse Input Ratio")
        );
        let inputPc1Ratio = createInput(
          (inputId = "pc_" + tabIndex + "_ratio"),
          (inputClass = "tabinput"),
          (inputValue = ""),
          (inputMaxLength = ""),
          (inputType = "text"),
          (inputStyle = []),
          (inputAttribute = ["readonly", "true"])
        );
        let divRCornersChild = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = ""),
          (elementText = " :1"),
          (elementStyle = ["marginTop", "7px", "float", "left"])
        );
    
        let centerPulseIncrement = createHTMLElement(
          (HTMLTag = "center"),
          (elementId = ""),
          (elementClass = "aligncenter"),
          (elementText = " Omnimeter Pulse Increment = ")
        );
        let bPulse1ValuesIs = createHTMLElement(
          (HTMLTag = "b"),
          (elementId = "pulse" + tabIndex + "valueis")
        );
        centerPulseIncrement.appendChild(bPulse1ValuesIs);
    
        let centerPulse1Cost = createHTMLElement(
          (HTMLTag = "center"),
          (elementId = ""),
          (elementClass = "aligncenter"),
          (elementText = " Cost = ")
        );
        let bPulse1Cost = createHTMLElement(
          (HTMLTag = "b"),
          (elementId = "pulse" + tabIndex + "Cost")
        );
        centerPulse1Cost.appendChild(bPulse1Cost);
    
        divRCorners.appendChild(labelPulseInputRatio);
        divRCorners.appendChild(inputPc1Ratio);
        divRCorners.appendChild(divRCornersChild);
        divRCorners.appendChild(document.createElement("br"));
        divRCorners.appendChild(centerPulseIncrement);
        divRCorners.appendChild(centerPulse1Cost);
    
        pulseDiv4.appendChild(divRCorners);
        pulseTab.appendChild(pulseDiv4);
        pulseTab.appendChild(document.createElement("br"));
    
        // Div5
        let pulseDiv5 = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = ""),
          (elementText = "Converted Value:"),
          (elementStyle = [])
        );
        let divRCorners2 = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = "rcorners"),
          (elementClass = "pulsediv"),
          (elementText = ""),
          (elementStyle = [])
        );
        let labelPc1ConvertLabel = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = "pc_" + tabIndex + "_convert_label"),
          (elementClass = "tab_pulse_label"),
          (elementText = `1 ${_OPTIONS_PULSE_VALUE[_DEFAULT_VALUES.pc_value_select]} = `)
        );
        let inputPc1ConvertedValue = createInput(
          (inputId = "pc_" + tabIndex + "_converted_value"),
          (inputClass = "tabinput fixedwidth"),
          (inputValue = ""),
          (inputMaxLength = ""),
          (inputType = "text"),
          (inputStyle = ["width", "66px"]),
          (inputAttribute = ["value", "", "readonly", "true"])
        );
        let selectPc1ConvertedSelect = createHTMLElement(
          (HTMLTag = "select"),
          (elementId = "pc_" + tabIndex + "_converted_select"),
          (elementClass = ""),
          (elementText = ""),
          (elementStyle = ["opacity", 1, "width", "108px"]),
          (elementAttribute = ["onchange", "getConvertedValue(" + tabIndex + ");"])
        );
    
        let centerPulseIncrement2 = createHTMLElement(
          (HTMLTag = "center"),
          (elementId = ""),
          (elementClass = "aligncenter"),
          (elementText = " Omnimeter Pulse Increment = ")
        );
        let bPulse1CalculateValuesIs = createHTMLElement(
          (HTMLTag = "b"),
          (elementId = "pulse" + tabIndex + "calculatevalueis")
        );
        centerPulseIncrement2.appendChild(bPulse1CalculateValuesIs);
    
        let centerPulseIncrement3 = createHTMLElement(
          (HTMLTag = "center"),
          (elementId = ""),
          (elementClass = "aligncenter"),
          (elementText = " Cost = ")
        );
        let bPulse1ConvertedCost = createHTMLElement(
          (HTMLTag = "b"),
          (elementId = "pulse" + tabIndex + "ConvertedCost")
        );
        centerPulseIncrement3.appendChild(bPulse1ConvertedCost);
    
        divRCorners2.appendChild(labelPc1ConvertLabel);
        divRCorners2.appendChild(inputPc1ConvertedValue);
        divRCorners2.appendChild(selectPc1ConvertedSelect);
        divRCorners2.appendChild(centerPulseIncrement2);
        divRCorners2.appendChild(centerPulseIncrement3);
    
        pulseDiv5.appendChild(divRCorners2);
        pulseTab.appendChild(pulseDiv5);
    
        // Apply button
        let pulseDiv6 = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "rollover"),
          (elementText = ""),
          (elementStyle = ["float", "left"])
        );
        let aPulse2Update = createHTMLElement(
          (HTMLTag = "a"),
          (elementId = "pulse2_update"),
          (elementClass = ""),
          (elementText = "Save & Apply"),
          (elementStyle = []),
          (elementAttribute = [
            "onclick",
            "javascript: return setSettingsPopupValues();",
          ])
        );
        pulseDiv6.appendChild(aPulse2Update);
        pulseTab.appendChild(pulseDiv6);
    
        // Add all change to the tab
        tabPulseKwh.appendChild(pulseTab);
      }
  }

  returnAllTabElements() {
    const deviceType = document.querySelector("#select_device_type").value
    const paramsToReturn = {}
    for (let element in this.tabElements) {
      let returnElement = true
      if (document.querySelector(this.tabElements[element]).value) {
        const valueToReturn = document.querySelector(this.tabElements[element]).value
        if (deviceType !== "meter" && element.startsWith('kwh_')) {
          returnElement = false
        } else if (deviceType === "meter" && element === 'kwh_currency' && valueToReturn === _DEFAULT_VALUES.kwh_currency) {
          returnElement = false
        } else if (element.endsWith('_value_select') && valueToReturn === _DEFAULT_VALUES.pc_value_select) {
          returnElement = false
        } else if (element.endsWith('_currency') && valueToReturn === _DEFAULT_VALUES.pc_currency) {
          returnElement = false
        } else if (element.endsWith('_converted_select') && valueToReturn === _DEFAULT_VALUES.pc_converted_select) {
          returnElement = false
        }

        if (returnElement) {
          paramsToReturn[`${devices[deviceType].prefix}${element}`] = encodeURIComponent(valueToReturn)
        }
      }
    }

    return paramsToReturn
  }

  getElementsToSaveInURL() {
    const paramsFromPulseTab = this.returnAllTabElements()
    let elementsToSave = ""
    for (let param in paramsFromPulseTab) {
      elementsToSave += paramsFromPulseTab[param] ? `&${param}=${paramsFromPulseTab[param]}` : "";
    }

    return elementsToSave
  }
}

class AnalogTab {
  constructor() {
    this.tabElements = {
      analog_1_name: "#analog_1_name",
      analog_list_1: "#analog_list_1",
      sensor_model_1: "#sensor_model_1",
      analog_min_1: "#analog_min_1",
      analog_max_1: "#analog_max_1",
      sensor_model_symbol_1: "#analog_1_symbol",
      formula_analog_in_1: "#formula_analog_in_1",

      analog_2_name: "#analog_2_name",
      analog_list_2: "#analog_list_2",
      sensor_model_2: "#sensor_model_2",
      analog_min_2: "#analog_min_2",
      analog_max_2: "#analog_max_2",
      sensor_model_symbol_2: "#analog_2_symbol",
      formula_analog_in_2: "#formula_analog_in_2",

      analog_3_name: "#analog_3_name",
      analog_list_3: "#analog_list_3",
      sensor_model_3: "#sensor_model_3",
      analog_min_3: "#analog_min_3",
      analog_max_3: "#analog_max_3",
      sensor_model_symbol_3: "#analog_3_symbol",
      formula_analog_in_3: "#formula_analog_in_3",

      analog_4_name: "#analog_4_name",
      analog_list_4: "#analog_list_4",
      sensor_model_4: "#sensor_model_4",
      analog_min_4: "#analog_min_4",
      analog_max_4: "#analog_max_4",
      sensor_model_symbol_4: "#analog_4_symbol",
      formula_analog_in_4: "#formula_analog_in_4",
    }
    this.init()
  }

  init() {
      this.createAnalogTab()
  }

  createAnalogTab() {
      const tabSize = 4;
      const tabAnalogData = document.querySelector("#tab_analog_data");
      const tabsControlAnalog = document.querySelector("#tabs_control_analog");
      let HTMLTag, elementId, elementClass, elementText, elementStyle, elementAttribute  = ""
      let inputId, inputClass, inputValue, inputMaxLength, inputType, inputStyle, inputAttribute = ""
      for (let x = 0; x < tabSize; x++) {
        let tabIndex = x + 1;
    
        let tabAnalog = createHTMLElement(
          (HTMLTag = "li"),
          (elementId = "li_tab_analog_" + tabIndex),
          (elementClass = ""),
          (elementText = ""),
          (elementStyle = ["opacity", 1]),
          (elementAttribute = [
            "onclick",
            "manageSettingTabs('tab_analog_" + tabIndex + "')",
          ])
        );

        let aTabAnalog = createHTMLElement(
          (HTMLTag = "a"),
          (elementId = "analog" + (tabIndex + 1) + "a"),
          (elementClass = ""),
          (elementText = "Sensor " + tabIndex),
          (elementStyle = []),
          (elementAttribute = [])
        );
        tabAnalog.appendChild(aTabAnalog);
        tabsControlAnalog.appendChild(tabAnalog);
    
        let analogTab = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = "tab_analog_" + tabIndex),
          (elementClass = "tabsdisplay"),
          (elementText = ""),
          (elementStyle = ["display", "block"])
        );
    
        // Divs
    
        let analogDiv = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "pulsediv")
        );
        let sensorNameDiv = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = "sensor_name"),
          (elementClass = "pulsediv")
        );
        let labelSensorName = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = "analog" + tabIndex + "_label_name"),
          (elementClass = "tablabel"),
          (elementText = "Name")
        );
        let inputSensorName = createInput(
          (inputId = "analog_" + tabIndex + "_name"),
          (inputClass = "tab_pulse_input"),
          (inputValue = ""),
          (inputMaxLength = "25"),
          (inputType = "text"),
          (inputStyle = []),
          (inputAttribute = [])
        );
        sensorNameDiv.appendChild(labelSensorName);
        sensorNameDiv.appendChild(inputSensorName);
        analogDiv.appendChild(sensorNameDiv);
        analogTab.appendChild(analogDiv);
    
        let sensorDiv = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = "sensor_type"),
          (elementClass = "pulsediv")
        );
        let sensorSelectType = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = ""),
          (elementClass = "tablabel"),
          (elementText = "Sensor type")
        );
        sensorDiv.appendChild(sensorSelectType);
        let analogList = createHTMLElement(
          (HTMLTag = "select"),
          (elementId = "analog_list_" + tabIndex),
          (elementClass = ""),
          (elementText = ""),
          (elementStyle = ["opacity", 1, "width", "108px"]),
          (elementAttribute = [])
        );
        sensorDiv.appendChild(analogList);
        analogDiv.appendChild(sensorDiv);
        analogTab.appendChild(analogDiv);
    
        let sensorModelDiv = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = "sensor_model"),
          (elementClass = "pulsediv")
        );
        let sensorModelSelect = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = ""),
          (elementClass = "tablabel"),
          (elementText = "Sensor model")
        );
        let sensorModelList = createHTMLElement(
          (HTMLTag = "select"),
          (elementId = "sensor_model_" + tabIndex),
          (elementClass = ""),
          (elementText = ""),
          (elementStyle = ["opacity", 1, "width", "108px"]),
          (elementAttribute = [])
        );
        sensorModelDiv.appendChild(sensorModelSelect);
        sensorModelDiv.appendChild(sensorModelList);
        analogDiv.appendChild(sensorModelDiv);
        analogTab.appendChild(analogDiv);
    
        let analogDivMin = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "pulsediv")
        );
        let labelMin = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = "analog_min_label_" + tabIndex),
          (elementClass = "tablabel"),
          (elementText = "Min AI Value")
        );
        let inputMin = createInput(
          (inputId = "analog_min_" + tabIndex),
          (inputClass = "tab_pulse_input"),
          (inputValue = ""),
          (inputMaxLength = ""),
          (inputType = "number"),
          (inputStyle = []),
          (inputAttribute = [])
        );
        analogDivMin.appendChild(labelMin);
        analogDivMin.appendChild(inputMin);
        analogDiv.appendChild(analogDivMin);
    
        let analogDivMax = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "pulsediv")
        );
        let labelMax = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = "analog_max_label_" + tabIndex),
          (elementClass = "tablabel"),
          (elementText = "Max AI Value")
        );
        let inputMax = createInput(
          (inputId = "analog_max_" + tabIndex),
          (inputClass = "tab_pulse_input"),
          (inputValue = ""),
          (inputMaxLength = ""),
          (inputType = "number"),
          (inputStyle = []),
          (inputAttribute = [])
        );
        analogDivMax.appendChild(labelMax);
        analogDivMax.appendChild(inputMax);
        analogDiv.appendChild(analogDivMax);
    
        let analogDivConvert = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "pulsediv")
        );
        let labelConvert = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = "formula_analog_in_" + tabIndex + "_label"),
          (elementClass = "tablabel"),
          (elementText = "Conversion formula")
        );
        let inputConvert = createInput(
          (inputId = "formula_analog_in_" + tabIndex),
          (inputClass = "tab_pulse_input"),
          (inputValue = ""),
          (inputMaxLength = ""),
          (inputType = "text"),
          (inputStyle = []),
          (inputAttribute = ["placeholder", "value"])
        );
    
        analogDivConvert.appendChild(labelConvert);
        analogDivConvert.appendChild(inputConvert);
        analogDiv.appendChild(analogDivConvert);
    
        let analogDivSymbol = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "pulsediv")
        );
        let labelSymbol = createHTMLElement(
          (HTMLTag = "label"),
          (elementId = "analog" + tabIndex + "_symbol_label"),
          (elementClass = "tablabel"),
          (elementText = "Symbol")
        );
        let inputSymbol = createInput(
          (inputId = "analog_" + tabIndex + "_symbol"),
          (inputClass = "tab_pulse_input"),
          (inputValue = ""),
          (inputMaxLength = "3"),
          (inputType = "text"),
          (inputStyle = []),
          (inputAttribute = ["placeholder", "Max. 3 characters"])
        );
    
        analogDivSymbol.appendChild(labelSymbol);
        analogDivSymbol.appendChild(inputSymbol);
        analogDiv.appendChild(analogDivSymbol);
    
        let applyButton = createHTMLElement(
          (HTMLTag = "div"),
          (elementId = ""),
          (elementClass = "rollover"),
          (elementText = ""),
          (elementStyle = ["float", "left"])
        );
        let aAnalog2Update = createHTMLElement(
          (HTMLTag = "a"),
          (elementId = "analog2_update"),
          (elementClass = ""),
          (elementText = "Save & Apply"),
          (elementStyle = []),
          (elementAttribute = [
            "onclick",
            "javascript: return setSettingsPopupValues();",
          ])
        );
        applyButton.appendChild(aAnalog2Update);
        analogTab.appendChild(applyButton);
    
        tabAnalogData.appendChild(analogTab);
      }
  }

  returnAllTabElements() {
    const paramsToReturn = {}
    for (let element in this.tabElements) {
      let returnElement = true
      if (document.querySelector(this.tabElements[element]).value) {
        const valueToReturn = document.querySelector(this.tabElements[element]).value
        if (element.startsWith('analog_min_') && parseInt(valueToReturn) === _DEFAULT_VALUES.analog_min) {
          returnElement = false
        } else if (element.startsWith('analog_max_') && parseInt(valueToReturn) === _DEFAULT_VALUES.analog_max) {
          returnElement = false
        } else if (element.startsWith('analog_list_') && valueToReturn === _DEFAULT_VALUES.sensor_type) {
          returnElement = false
        }

        if (returnElement) {
          paramsToReturn[element] = encodeURIComponent(valueToReturn)
        }
      }
    }

    return paramsToReturn
  }

  getElementsToSaveInURL() {
    const paramsFromAnalogTab = this.returnAllTabElements()
    let elementsToSave = ""
    for (let param in paramsFromAnalogTab) {
      elementsToSave += paramsFromAnalogTab[param] ? `&${param}=${paramsFromAnalogTab[param]}` : "";
    }

    return elementsToSave
  }

}

class WireTab {
  constructor() {
      this.init()
  }

  init() {
      this.createWireTab()
  }

  createWireTab() {
      const tabWireData = document.querySelector("#tab_wire_data");
      let HTMLTag, elementId, elementClass, elementText, elementStyle, elementAttribute  = ""
      let inputId, inputClass, inputValue, inputMaxLength, inputType, inputStyle, inputAttribute = ""
      // Add the wire to the input select
      let wireDiv = createHTMLElement(
        (HTMLTag = "div"),
        (elementId = "wire_list"),
        (elementClass = "wireDiv")
      );
    
      // wireListDiv
      let wireListDiv = createHTMLElement(
        (HTMLTag = "div"),
        (elementId = "div_wire_list")
      );
      let wireSelectListLabel = createHTMLElement(
        (HTMLTag = "label"),
        (elementId = ""),
        (elementClass = "tablabel"),
        (elementText = "1 Wire Sensor")
      );
    
      let wireList = createHTMLElement(
        (HTMLTag = "select"),
        (elementId = "select_wire_sensor"),
        (elementClass = ""),
        (elementText = ""),
        (elementStyle = ["opacity", 1, "width", "160px"]),
        (elementAttribute = [])
      );
    
      wireListDiv.appendChild(wireSelectListLabel);
      wireListDiv.appendChild(wireList);
      wireDiv.appendChild(wireListDiv);
      //
      let wireSensor1;
    
      for (let key in _ALL_IOSTACK_FIELDS) {
        if (key.startsWith("ow_")) {
          let wireSensor = document.createElement("option");
          wireSensor.id = key;
          wireSensor.value = key;
          wireSensor.text = _ALL_IOSTACK_FIELDS[key];
    
          wireList.appendChild(wireSensor);
          //Create each sensor options
          let showDivWire = key === "ow_1_1_degc" ? "block" : "none";
    
          wireSensor1 = createHTMLElement(
            (HTMLTag = "div"),
            (elementId = `div_${key}`),
            (elementClass = ""),
            (elementText = ""),
            (elementStyle = ["display", showDivWire]),
            (elementAttribute = [])
          );
    
          // div for name
          let divWireName = createHTMLElement(
            (HTMLTag = "div"),
            (elementId = "div_name_" + key),
            (elementClass = "wireDiv"),
            (elementText = ""),
            (elementStyle = ""),
            (elementAttribute = [])
          );
          let wireName = createHTMLElement(
            (HTMLTag = "label"),
            (elementId = ""),
            (elementClass = "tablabel"),
            (elementText = "Name")
          );
          let inputWireName = createInput(
            (inputId = `name_${key}`),
            (inputClass = "tab_pulse_input"),
            (inputValue = ""),
            (inputMaxLength = ""),
            (inputType = "text"),
            (inputStyle = []),
            (inputAttribute = ["placeholder", _ALL_IOSTACK_FIELDS[key]])
          );
          divWireName.appendChild(wireName);
          divWireName.appendChild(inputWireName);
          wireSensor1.appendChild(divWireName);
          wireDiv.appendChild(wireSensor1);
          // End div for name
    
          // div for formula
          let divWireFormula = createHTMLElement(
            (HTMLTag = "div"),
            (elementId = "div_formula_" + key),
            (elementClass = "wireDiv"),
            (elementText = ""),
            (elementStyle = ""),
            (elementAttribute = [])
          );
          let wireFormula = createHTMLElement(
            (HTMLTag = "label"),
            (elementId = ""),
            (elementClass = "tablabel"),
            (elementText = "Conversion formula")
          );
          let isTemp = key.includes("degc") ? "value * 9 / 5 + 32" : "value";
          let inputWireFormula = createInput(
            (inputId = `formula_${key}`),
            (inputClass = "tab_pulse_input"),
            (inputValue = ""),
            (inputMaxLength = ""),
            (inputType = "text"),
            (inputStyle = []),
            (inputAttribute = ["placeholder", isTemp])
          );
          divWireFormula.appendChild(wireFormula);
          divWireFormula.appendChild(inputWireFormula);
          wireSensor1.appendChild(divWireFormula);
          // End div for formula
    
          // div for symbol
          let divWireSymbol = createHTMLElement(
            (HTMLTag = "div"),
            (elementId = "div_symbol_" + key),
            (elementClass = "pulsediv"),
            (elementText = ""),
            (elementStyle = ""),
            (elementAttribute = [])
          );
          let wireSymbolLabel = createHTMLElement(
            (HTMLTag = "label"),
            (elementId = ""),
            (elementClass = "tablabel"),
            (elementText = "Symbol")
          );
          let symbolChar = key.includes("degc")
            ? "E.g. °F - Max. 3 Chars"
            : "Max. 3 characters";
          let inputWireSymbol = createInput(
            (inputId = `symbol_${key}`),
            (inputClass = "tab_pulse_input"),
            (inputValue = ""),
            (inputMaxLength = "3"),
            (inputType = "text"),
            (inputStyle = []),
            (inputAttribute = ["placeholder", symbolChar])
          );
          divWireSymbol.appendChild(wireSymbolLabel);
          divWireSymbol.appendChild(inputWireSymbol);
          wireSensor1.appendChild(divWireSymbol);
          // End Symbol
        }
      }
    
      tabWireData.appendChild(wireDiv);
    
      let applyButton = createHTMLElement(
        (HTMLTag = "div"),
        (elementId = ""),
        (elementClass = "rollover"),
        (elementText = ""),
        (elementStyle = ["float", "left"])
      );
      let aWire2Update = createHTMLElement(
        (HTMLTag = "a"),
        (elementId = "wire2_update"),
        (elementClass = ""),
        (elementText = "Save & Apply"),
        (elementStyle = []),
        (elementAttribute = [
          "onclick",
          "javascript: return setSettingsPopupValues();",
        ])
      );
      applyButton.appendChild(aWire2Update);
      tabWireData.appendChild(applyButton);
  }

  returnAllTabElements() {
    const deviceType = document.querySelector("#select_device_type").value
    const paramsToReturn = {}
    if (deviceType === "iostack") {
      for (let key in devices[deviceType].allFields) {
        if (key.startsWith("ow_")) {
          const wireName = document.querySelector(`#name_${key}`).value;
          const wireFormula = document.querySelector(`#formula_${key}`).value;
          const wireSymbol = document.querySelector(`#symbol_${key}`).value;
    
          if (wireName != "") {
            paramsToReturn[`name_${key}`] = encodeURIComponent(wireName)
          }
          if (wireFormula != "") {
            paramsToReturn[`formula_${key}`] = encodeURIComponent(wireFormula.toLowerCase())
          }
          if (wireSymbol != "") {
            paramsToReturn[`symbol_${key}`] = encodeURIComponent(wireSymbol)
          }
        }
      }
    }
    
    return paramsToReturn
  }

  getElementsToSaveInURL() {
    const paramsFromWireTab = this.returnAllTabElements()
    let elementsToSave = ""
    for (let param in paramsFromWireTab) {
      elementsToSave += paramsFromWireTab[param] ? `&${param}=${paramsFromWireTab[param]}` : "";
    }

    return elementsToSave
  }

}
class LayoutFieldsTab {
  constructor() {
      this.tabElements = { //Key should be the same value that will be in the url
        total_field: "#total_field",
        line_graph_fields: "#line_graph_fields",
        compare: "#compare",
        bar_graph_field: "#bar_graph_field", // 0 - Realtime | 1 - History
        table_fields: "#tablefields",
        historical: "#history_color",
        layout: "#layout",
      }
      this.init();
  }

  init() {
      this.fillColorFields()
      this.fillLayout()
      const htmlCompare = document.querySelector(this.tabElements.compare);
      htmlCompare.setAttribute('onchange', 'tabs.layoutTab.handleRelativeView(this.value)');
  }

  fillLayoutFieldsTab() {
    let deviceType = document.querySelector("#select_device_type").value;
    deviceType = deviceType.toLowerCase();
    this.fillTotalFields(deviceType);
    this.fillLineGraphFields(deviceType)
    this.fillCompare(deviceType);
    this.fillBarGraphFields(deviceType)
    this.fillTableFields(deviceType)
  
    this.handleLineGraphOptions()
    this.handleTableOptions()
    this.handleLayoutOptions()
  }

  fillTotalFields(deviceType) {
    const totalField = document.querySelector(this.tabElements.total_field);
    totalField.innerHTML = ""
    let { selectTotalField } = devices[deviceType]
    
    const total_field = _REQUEST.has(selectTotalField)
      ? _REQUEST.get(selectTotalField)
      : devices[deviceType].defaultTotalField;
  
    const optionsTotal = devices[deviceType].getTotalFields();
    const { allFields } = devices[deviceType];
  
    for (let key in optionsTotal) {
      let option = document.createElement("option");
      const value = allFields.hasOwnProperty(key) ? allFields[key] : optionsTotal[key]["name"]

      option.value = key;
      option.text = value;
      if (total_field == key) {
        option.setAttribute("selected", "");
      }
  
      totalField.add(option);
    }

  }

  fillLineGraphFields(deviceType) {
    const { selectLineGraphFields } = devices[deviceType];
    const fieldsForLineGraph = devices[deviceType].getFieldsForLineGraph()
    const lineGraphFieldsSelect = document.querySelector(this.tabElements.line_graph_fields);
    let tmpLineGraphFieldsValue = _REQUEST.has(selectLineGraphFields) ? _REQUEST.get(selectLineGraphFields) : "";
    tmpLineGraphFieldsValue = tmpLineGraphFieldsValue.split('~')
    lineGraphFieldsSelect.innerHTML = ""

    for (let key in fieldsForLineGraph) {
      let fieldOption = document.createElement("option");
      fieldOption.value = key;
      fieldOption.text = fieldsForLineGraph[key];
      if (tmpLineGraphFieldsValue instanceof Array && tmpLineGraphFieldsValue.includes(key)) {
        fieldOption.setAttribute("selected", "");
      }

      lineGraphFieldsSelect.add(fieldOption);
    }
  }

  handleLineGraphOptions() {
    $(this.tabElements.line_graph_fields).each(function () {
      let select = $(this),
      values = {};
      $("option", select)
        .each(function (i, option) {
          values[option.value] = option.selected;
        })
        .click(function (event) {
          values[this.value] = !values[this.value];
          var cnt = 0;
          $("option", select).each(function (i, option) {
            if (values[option.value]) cnt++;
  
            if (cnt > 4 && values[option.value]) {
              alert("Please select only 4 values");
              $("option", select).each(function (i, opt) {
                values[opt.value] = false;
                opt.selected = false;
              });
              $("select#graphfields option").removeAttr("selected");
            } else {
              option.selected = values[option.value];
            }
          });
        });
    });
  }

  fillCompare(deviceType) {
    const { selectCompare } = devices[deviceType]
    const htmlCompare = document.querySelector(this.tabElements.compare);
    let urlCompare = 0;

    if (_REQUEST.has(selectCompare)) {
      htmlCompare.removeAttribute("disabled");
      urlCompare = _REQUEST.get(selectCompare).toLowerCase();
      urlCompare = urlCompare.trim();
      if (urlCompare == 1 || urlCompare == 0) {
        this.handleRelativeView(urlCompare);
        htmlCompare.value = urlCompare == 1 ? 1 : 0;
        if (urlCompare == 1) {
          const selectCompareMinY = devices[deviceType].compareMinY
          const selectCompareMaxY = devices[deviceType].compareMaxY
          if (_REQUEST.has(selectCompareMinY))
            document.querySelector("#compare_min").value = _REQUEST.get(selectCompareMinY);
          if (_REQUEST.has(selectCompareMaxY))
            document.querySelector("#compare_max").value = _REQUEST.get(selectCompareMaxY);
        }
      }
    } else {
      if (htmlCompare.value == 1) {
        htmlCompare.value = 0;
        document.querySelector("#compare_min").value = "";
        document.querySelector("#compare_max").value = "";
        htmlCompare.removeAttribute("disabled");
      }
      if (selectCompare === "")  {
        htmlCompare.setAttribute("disabled", "");
      } else {
        htmlCompare.removeAttribute("disabled");
      }
      this.handleRelativeView();
    }
  }

  handleRelativeView(value = 0) {
    const compareSettings = document.querySelector("#compareSettings");
    compareSettings.style.display = value == 1 ? "block" : "none";
  }

  fillBarGraphFields(deviceType) {
    document.querySelector(this.tabElements.bar_graph_field).innerHTML = ""
    isOnLoad = isOnLoad ? false : true

    let isTotalField = true
    const totalFieldsToCreate = devices[deviceType].getTotalFields()

    this.createOptionsElementForBarGraphField(isTotalField, deviceType)
    
    if (Object.keys(totalFieldsToCreate).length > 0) {
      let option = document.createElement("option");
      option.text = "   --------------------   "
      option.setAttribute("disabled", "");
      document.querySelector(this.tabElements.bar_graph_field).add(option);
    }

    isTotalField = false
    this.createOptionsElementForBarGraphField(isTotalField, deviceType)
  }

  createOptionsElementForBarGraphField(isTotalField, deviceType){
    const totalFieldsToCreate = devices[deviceType].getTotalFields()
    const { barGraphFields } = devices[deviceType]
    const elementsToCreate = isTotalField ? totalFieldsToCreate : barGraphFields
    let valueToCheck = true
    const barGraphFieldSelect = document.querySelector(this.tabElements.bar_graph_field)
    const tmpBarGraphFieldValue = isOnLoad ? "" : document.querySelector(this.tabElements.bar_graph_field).value;

    $.each(elementsToCreate, function (key, val) {
      if (deviceType === "meter") {
        if (isTotalField) {
          valueToCheck =  _V4_GRAPH_FIELDS.indexOf(key) === -1 || deviceVersion === "v4" || deviceVersion === "v3" ? true: false
         } else {
          valueToCheck = val.type === "v3" || deviceVersion === "v4" ? true: false
         }
      }
  
      if (valueToCheck) {
        let option = document.createElement("option");
        option.value = key;
        option.text = val.name;
        if (tmpBarGraphFieldValue === key || _REQUEST.has(devices[deviceType].selectBarGraphFields)) {
          if (key === _REQUEST.get(devices[deviceType].selectBarGraphFields)) {
            option.setAttribute("selected", "");
          }
        }
        barGraphFieldSelect.add(option);
      }
    });
  }

  fillTableFields(deviceType) {
    const { tableFields } = devices[deviceType];
    const fieldsForTable = devices[deviceType].getFieldsForTable()
    const tableFieldsSelect = document.querySelector(this.tabElements.table_fields);
    tableFieldsSelect.innerHTML = ""
    let tableFieldsInURL = _REQUEST.has(tableFields) ? _REQUEST.get(tableFields) : ""
    tableFieldsInURL = tableFieldsInURL.split("~");

    for (let key in fieldsForTable) {
      if(!key.startsWith('pulse_cnt_') && !key.startsWith('converted_')) {
        let fieldOption = document.createElement("option");
        fieldOption.value = key;
        fieldOption.text = fieldsForTable[key];
        if (tableFieldsInURL.includes(key)) {
          fieldOption.setAttribute("selected", "");
        }

        tableFieldsSelect.add(fieldOption);
      }
    }

  }

  handleTableOptions() {
    $(this.tabElements.table_fields).each(function () {
      let select = $(this),
      values = {};
      $("option", select)
        .each(function (i, option) {
          values[option.value] = option.selected;
        })
        .click(function (event) {
          values[this.value] = !values[this.value];
          $("option", select).each(function (i, option) {
            option.selected = values[option.value];
          });
        });
    });
  }

  fillColorFields() {
    const historyColor = document.querySelector(this.tabElements.historical);

    for (let key in OPTIONS_COLOR) {
      let option = document.createElement("option");
      option.value = key;
      option.text = OPTIONS_COLOR[key];
      if (_REQUEST.get("historical") == key) {
        option.setAttribute("selected", "");
      }
      historyColor.add(option);
    }
  }

  fillLayout() {
    const layoutSelect = document.querySelector(this.tabElements.layout)
    layoutSelect.innerHTML = ""
    let layoutInURL = _REQUEST.has("layout") ? _REQUEST.get("layout") : ""
    layoutInURL = layoutInURL.split("~");

    for (let key in _SUPPORTED_LAYOUTS) {
      let fieldOption = document.createElement("option");
      fieldOption.value = key;
      fieldOption.text = _SUPPORTED_LAYOUTS[key];
      if (layoutInURL.includes(key)) {
        fieldOption.setAttribute("selected", "");
      }
      layoutSelect.add(fieldOption)
    }
  }

  handleLayoutOptions() {
    $(this.tabElements.layout).each(function () {
      let select = $(this),
      values = {};
      $("option", select)
        .each(function (i, option) {
          values[option.value] = option.selected;
        })
        .click(function (event) {
          var curSelection = this.value;
          values[this.value] = !values[this.value];
          $("option", select).each(function (i, option) {
            if (values[option.value] && option.value == "hide_all") {
              if (curSelection == "hide_all") {
                $("option", select).each(function (i, opt) {
                  values[opt.value] = false;
                  opt.selected = false;
                });
                $("select#layout option").removeAttr("selected");
                values["hide_all"] = true;
              } else {
                values[option.value] = false;
                option.selected = false;
              }
            }
            option.selected = values[option.value];
          });
        });
    });
  }

  returnAllTabElements() {
    const paramsToReturn = {}
    const deviceType = document.querySelector("#select_device_type").value
    for (let element in this.tabElements) {
      let returnElement = true
      let valueToReturn = $(this.tabElements[element]).val() ? $(this.tabElements[element]).val() : 0

      if (valueToReturn.length !== 0) {
        if (element === 'total_field' && valueToReturn === devices[deviceType].defaultTotalField) {
          returnElement = false 
        } else if (element === 'line_graph_fields') {
          valueToReturn = valueToReturn.slice(0,4)
          valueToReturn = valueToReturn.join("~");
        } else if (element === 'bar_graph_field' && valueToReturn === devices[deviceType].barGraphField) {
          returnElement = false 
        } else if (element === 'compare') {
          if (parseInt(valueToReturn) === _DEFAULT_VALUES.compare) {
            returnElement = false 
          } else {
            // Min / Max for relative view
            let minYValue = document.querySelector("#compare_min");
            let maxYValue = document.querySelector("#compare_max");
            minYValue = parseFloat(minYValue.value);
            maxYValue = parseFloat(maxYValue.value);

            if (!isNaN(minYValue)) {
              paramsToReturn.compare_min_y = minYValue
            }
            if (!isNaN(maxYValue)) {
              paramsToReturn.compare_max_y = maxYValue
            }

          }

        } else if (element === 'table_fields') {
          valueToReturn = valueToReturn.join("~");
        } else if (element === 'historical' && valueToReturn === _DEFAULT_VALUES.historical) {
          returnElement = false 
        } else if (element === 'layout') {
          const compareField = paramsToReturn.compare ? paramsToReturn.compare : "";
          if (compareField == 1) {
            if (valueToReturn.includes("show_range")) {
              let tmpLayout = [];
              valueToReturn.forEach(function (element) {
                if (element !== "show_range") {
                  tmpLayout.push(element);
                }
              });
              valueToReturn = tmpLayout;
            }
          }
          valueToReturn = valueToReturn.join("~");
        }

        if (returnElement) {
          paramsToReturn[element] = valueToReturn
        }
      }
    }
    return paramsToReturn
  }

  getElementsToSaveInURL() {
    const paramsFromLayoutTab = this.returnAllTabElements()
    const deviceType = document.querySelector("#select_device_type").value
    let elementsToSave = ""
    for (let param in paramsFromLayoutTab) {
      let urlParamName = param === 'layout' || param === 'historical' ? param : `${devices[deviceType].prefix}${param}`
      elementsToSave += paramsFromLayoutTab[param] ? `&${urlParamName}=${paramsFromLayoutTab[param]}` : "";
    }
    return elementsToSave
  }

}

class ReleaseNotesTab {
  constructor() {
      this.init();
  }

  init() {
      this.fillReleaseNotes()
  }

  fillReleaseNotes() {
      const releaseFile = new XMLHttpRequest();
      const widget_version = "7.0";
      let releaseText = ""
      const url = location.protocol + "//" + location.host + location.pathname + "release.txt?v=" + widget_version;
      releaseFile.open("GET", url, true);
      releaseFile.send();
      releaseFile.onreadystatechange = function () {
          if (releaseFile.readyState == 4 && releaseFile.status == 200) {
              releaseText = releaseFile.responseText;
              releaseText = releaseText.split("\r").join("<br>");
              releaseText = releaseText.split("\n").join("<br>");
              releaseText = releaseText.split("*").join("<li>");
              document.querySelector("#release_text").innerHTML = releaseText;
          }
      };

  }
}